import React, { useRef } from "react";
import { useDropzone } from "react-dropzone";
import EventActionCard from "./EventActionCard";

const UploadEventActionCard = ({
  onFilesSelected,
  uploadPercentage = 0,
  multiple = false,
  classes,
  disabled,
  ...props
}) => {
  const fileInputRef = useRef();

  const { getRootProps, getInputProps } = useDropzone({
    noClick: true,
    noKeyboard: true,
    disabled: uploadPercentage > 0,
    multiple,
    onDrop: (acceptedFiles) => {
      if (onFilesSelected) {
        onFilesSelected(acceptedFiles);
      }
    },
  });

  const handleButtonClick = (e) => {
    e.preventDefault();
    if (uploadPercentage <= 0 && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div
      {...getRootProps()}
      className={`${classes} d-flex flex-column align-items-center justify-content-center event-action-card p-3 m-3`}
    >
      <input
        {...getInputProps()}
        ref={fileInputRef}
        multiple={multiple}
        onChange={(e) => {
          const files = Array.from(e.target.files); // always an array
          onFilesSelected && onFilesSelected(files);
          e.target.value = null;
        }}
      />
      <EventActionCard
        {...props}
        isDisabled={disabled || uploadPercentage > 0}
        onClick={handleButtonClick}
        hideClasses={true}
      />
    </div>
  );
};

export default UploadEventActionCard;
